export enum RentDrawdownMode {
	ToZero = "to-zero",
	Perpetual = "perpetual",
}
